// extracted by mini-css-extract-plugin
export var dateLabel = "_redotech-redo-web-lib-date-range-date-label";
export var dateLabelError = "_redotech-redo-web-lib-date-range-date-label-error";
export var fullWidth = "_redotech-redo-web-lib-date-range-full-width";
export var smaller = "_redotech-redo-web-lib-date-range-smaller";